// テキスト差分の共有ユーティリティ（ディクテーション採点）。
// デスクトップ版 src/renderer/text-diff.js（window.TextDiff）の ESM 移植。
// LCS 単語アライメントで「原文の各語が解答で当てられたか」を返す。

// 単語列 a, b の最長共通部分列(LCS)をたどり、各語が「共通(=当たり)」かを返す。
// 戻り値: { keepA:boolean[], keepB:boolean[], lcs:number }
export function alignLCS(a, b) {
  const n = a.length
  const m = b.length
  const dp = Array.from({ length: n + 1 }, () => new Int32Array(m + 1))
  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1])
    }
  }
  const keepA = new Array(n).fill(false)
  const keepB = new Array(m).fill(false)
  let i = 0
  let j = 0
  while (i < n && j < m) {
    if (a[i] === b[j]) {
      keepA[i] = true
      keepB[j] = true
      i++
      j++
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      i++
    } else {
      j++
    }
  }
  return { keepA, keepB, lcs: dp[0][0] }
}

// b の各語について「a に対して変更されていないか」を返す（参考: ライティング用途）。
export function lcsKeep(a, b) {
  return alignLCS(a, b).keepB
}

// 英単語トークンに分割（採点用）。
export function tokenizeWords(text) {
  return String(text).match(/[A-Za-z0-9][A-Za-z0-9'-]*/g) || []
}

// 比較用の正規化（小文字化・前後の記号除去）。採点で句読点/大文字小文字を不問にする。
export function normalizeWord(w) {
  return String(w).toLowerCase().replace(/^[^a-z0-9']+|[^a-z0-9']+$/g, '')
}
